export enum AvailableSearchParams {
  THEME = 'theme',
  APP = 'app',
  MANUAL_REVIEW = 'manualReview'
}

export const getSearchParam = (key: AvailableSearchParams, defaultValue?: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key) ?? defaultValue;
};

export const getManualReviewOverride = () => {
  const value = getSearchParam(AvailableSearchParams.MANUAL_REVIEW);

  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return undefined;
};
